<script setup lang="ts">
  import { SelectInput } from '@/shared/ui';
  import { NOTIFICATION_QUANTITY_OPTIONS, type NotificationItemsPerPage } from '../model/types';

  defineProps<{
    modelValue: NotificationItemsPerPage;
  }>();

  const emit = defineEmits<{
    'update:modelValue': [value: NotificationItemsPerPage];
    change: [value: NotificationItemsPerPage];
  }>();

  const handleChange = (value: string | number) => {
    const quantity = value === 'all' ? 'all' : (Number(value) as NotificationItemsPerPage);
    emit('update:modelValue', quantity);
    emit('change', quantity);
  };
</script>

<template>
  <SelectInput
    :model-value="modelValue"
    data-testid="notification-quantity-select"
    :options="NOTIFICATION_QUANTITY_OPTIONS"
    @update:model-value="handleChange"
  />
</template>
